import { jsx as _jsx } from "react/jsx-runtime";
import { Images } from "@air/next-icons";
import { useSelector } from "react-redux";
import { CommentCount } from "~/components/Discussions/DiscussionsMenu/components/CommentCount";
import { DiscussionsMenuItem } from "~/components/Discussions/DiscussionsMenu/components/DiscussionsMenuItem";
import { centralizedClipLibraryCommentCountSelector } from "~/store/centralizedClip/selectors";
export const DiscussionsLibraryMenuItem = ()=>{
    const libraryCommentCount = useSelector(centralizedClipLibraryCommentCountSelector);
    return /*#__PURE__*/ _jsx(DiscussionsMenuItem, {
        adornmentRight: /*#__PURE__*/ _jsx(CommentCount, {
            count: libraryCommentCount
        }),
        thumbnail: /*#__PURE__*/ _jsx("div", {
            className: "flex h-full items-center justify-center bg-blue-3 text-blue-9",
            children: /*#__PURE__*/ _jsx(Images, {
                className: "size-5"
            })
        }),
        title: "All assets & files"
    });
};
